import { DataSecurityApplicationReference } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type ApplicationsIdMapState = SyncState<Record<number, DataSecurityApplicationReference>>;

export const defaultApplicationsIdMapState: ApplicationsIdMapState = { data: {} };
